import { useMelwaysInfo } from '@seek/melways-react';
import type { Language } from '@seek/melways-sites';
import {
  IconPositive,
  HiddenVisually,
  Stack,
  Text,
  Columns,
  Column,
  Box,
  IconRenderer,
} from 'braid-design-system';

import { getScreenReaderDate } from 'src/wip_modules/util/date';

interface Props {
  label: string;
  tone: 'positive' | 'neutral';
  date: string;
  dateUtc: string | undefined;
  desc?: string;
}

export const ApplicationStatus = ({
  label,
  tone,
  date,
  dateUtc,
  desc,
}: Props) => {
  const { language } = useMelwaysInfo();

  return (
    <Box position="relative">
      <Columns space="xxsmall">
        <Column width="content">
          <Box position="relative" height="full">
            <Text tone={tone === 'neutral' ? 'secondary' : tone}>
              {tone === 'positive' ? <IconPositive /> : null}
              {tone === 'neutral' ? (
                <IconRenderer>
                  {({ className }) => (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className={className}
                      fill="currentColor"
                    >
                      <path d="M12 23C5.935 23 1 18.065 1 12S5.935 1 12 1s11 4.935 11 11-4.935 11-11 11Zm0-20c-4.963 0-9 4.038-9 9 0 4.963 4.037 9 9 9s9-4.037 9-9c0-4.962-4.037-9-9-9Z" />
                      <path d="M16 13H8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2Z" />
                    </svg>
                  )}
                </IconRenderer>
              ) : null}
            </Text>
          </Box>
        </Column>
        <Column>
          <Stack space="small">
            <Text tone={tone === 'neutral' ? 'secondary' : tone}>{label}</Text>
            <Text tone="secondary" size="small">
              {`${date} `}
              {dateUtc ? (
                <HiddenVisually>
                  {getScreenReaderDate(dateUtc, language as Language)}
                </HiddenVisually>
              ) : null}
            </Text>
            {Boolean(desc) ? <Text tone="secondary">{desc}</Text> : null}
          </Stack>
        </Column>
      </Columns>
    </Box>
  );
};
